import { useTranslation } from 'next-i18next'
import React from 'react'
import FAQ from 'src/components/FAQ'
import HostFAQImg from '../../../public/images/host-faq-img.png'

const FAQSection = () => {
  const { t } = useTranslation('landing')
  const { t: tStats } = useTranslation('platform_stats')
  return (
    <FAQ
      title={t('INDEX_FAQ.TITLE')}
      faqs={t('INDEX_FAQ.ITEMS', {
        returnObjects: true,
        cities: tStats('CITIES')
      })}
      image={HostFAQImg}
      imageAlt={t('INDEX_FAQ.IMAGE_ALT')}
      titleAs="h2"
      whatsappMsg={t('INDEX_FAQ.WHATSAPP_MSG')}
      surface="landing"
    />
  )
}

export default React.memo(FAQSection)
